import { render } from "./ButtonInner.vue?vue&type=template&id=0ff401ac&scoped=true"
import script from "./ButtonInner.vue?vue&type=script&lang=js"
export * from "./ButtonInner.vue?vue&type=script&lang=js"

import "./ButtonInner.vue?vue&type=style&index=0&id=0ff401ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff401ac"]])

export default __exports__